export default __webpack_public_path__ + "static/header-nodejs-99b63f628a2340da33e40e478cb526f0.jpg";